import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import usePageRouter from '@/dialogs-routable/_hooks/usePageRouter';

DiscoverBanner.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      endDate: PropTypes.string
    })
  }).isRequired,
  creator: PropTypes.shape({
    data: PropTypes.shape({
      firstName: PropTypes.string
    })
  }).isRequired
};

export default function DiscoverBanner(props) {
  const { project, creator } = props;

  const launch = useDialogLauncher();
  const { history } = usePageRouter();

  function showConnectDialog() {
    launch(DialogManager.QuestionDiscover.Config(project.id));
  }

  if (
    isExpired(project.data.endDate)
  ) {
    return (
      <Wrapper
        color="gray"
        creator={creator}
        title="The timeframe for this project has ended."
        subtitle={(
          <>
            But you can explore other opportunities to collaborate and make an impact.
          </>
        )}
      >
        <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
          <ConnectButton color="gray" onClick={() => history.push(`/opportunities`)}>
            Explore opportunities
          </ConnectButton>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper
      creator={creator}
      title={`Want to get involved in ${creator.data.firstName}'s project?`}
      subtitle={(
        <>
          Connect with {creator.data.firstName} to share your interest! Ask questions, offer ideas,
          or suggest someone else who might be a good fit!
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton onClick={showConnectDialog}>
          Start the conversation
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
